import { createFileRoute } from "@tanstack/react-router";
import FrontCameraAIFlow from "@/features/assessments/pages/front-camera-ai/FrontCameraAiFlow";

export const Route = createFileRoute("/$locale/$partner/_camera/front-camera-ai")({
	component: FrontCameraAIFlow,
});
